export function composeEventHandlers(...handlers) {
  return function handleEvent(evt) {
    handlers.some(fn => {
      fn?.(evt);
      return evt.defaultPrevented;
    });
  };
}